import React, { useContext, useState, useEffect } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import Fade from "react-reveal/Fade";
import { IoMenuSharp, IoHomeSharp } from "react-icons/io5";
import { HiDocumentText } from "react-icons/hi";
import { BsFillGearFill } from "react-icons/bs";
import { MdPhone } from "react-icons/md";
import { FaUser, FaFolderOpen } from "react-icons/fa";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CloseIcon from "@material-ui/icons/Close";
import { Button } from '@material-ui/core';
import { LanguageContext } from "../../contexts/LanguageContext";
import { GrCertificate } from "react-icons/gr";
import certIcon from "../../assets/png/certificate.png";



import "./Navbar.css";
import { headerData } from "../../data/headerData";
import { ThemeContext } from "../../contexts/ThemeContext";
import gsap from "gsap";

function Navbar() {
  const { theme, setHandleDrawer } = useContext(ThemeContext);

  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
    setHandleDrawer();
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setHandleDrawer();
  };

  const useStyles = makeStyles((t) => ({
    navMenu: {
      fontSize: "2.5rem",
      color: theme.tertiary,
      cursor: "pointer",
      position: "fixed",
      top: "30px",
      right: "30px",
      transition: "color 0.3s",
      "&:hover": {
        color: theme.primary,
      },
      [t.breakpoints.down("md")]: {
        // Tablettes
        fontSize: "2rem",
        top: "20px",
        right: "20px",
      },
      [t.breakpoints.down("sm")]: {
        // Petits écrans
        fontSize: "1.8rem",
        top: "15px",
        right: "20px",
      },
    },
    MuiDrawer: {
      padding: "1.5em",
      width: "14em",
      fontSize: "1.5rem",
      background: theme.secondary,
      borderTopRightRadius: "40px",
      borderBottomRightRadius: "40px",
      [t.breakpoints.down("md")]: {
        // Tablettes
        width: "12em",
      },
      [t.breakpoints.down("sm")]: {
        // Téléphones
        width: "10em",
        fontSize: "1.2rem",
        padding: "1em",
      },
    },
    closebtnIcon: {
      fontSize: "2rem",
      color: theme.primary,
      position: "absolute",
      right: 40,
      top: 40,
      cursor: "pointer",
      transition: "color 0.2s",
      "&:hover": {
        color: theme.tertiary,
      },
      [t.breakpoints.down("md")]: {
        right: 30,
        top: 30,
        fontSize: "1.8rem",
      },
      [t.breakpoints.down("sm")]: {
        right: 20,
        top: 20,
        fontSize: "1.5rem",
      },
    },
    drawerItem: {
      margin: "1.5rem 0",
      borderRadius: "50px",
      background: theme.secondary,
      color: theme.primary,
      width: "95%",
      height: "60px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-evenly",
      padding: "0 10px",
      border: "2px solid",
      borderColor: theme.primary,
      transition: "background-color 0.2s, color 0.2s",
      "&:hover": {
        background: theme.primary,
        color: theme.secondary,
      },
      [t.breakpoints.down("md")]: {
        // Tablettes
        height: "55px",
        fontSize: "1.2rem",
      },
      [t.breakpoints.down("sm")]: {
        // Téléphones
        height: "50px",
        fontSize: "1rem",
        width: "100%",
        padding: "0 15px",
      },
    },
    drawerLinks: {
      fontSize: "1rem",
      fontWeight: 600,
      [t.breakpoints.down("md")]: {
        fontSize: "1.1rem",
      },
      [t.breakpoints.down("sm")]: {
        fontSize: "1rem",
      },
    },
    drawerIcon: {
      fontSize: "1rem",
      [t.breakpoints.down("md")]: {
        fontSize: "1.4rem",
      },
      [t.breakpoints.down("sm")]: {
        fontSize: "1.2rem",
      },
    },
  }));
  const [showShortname, setShowShortname] = useState(false);

  const { language, switchLanguage } = useContext(LanguageContext);  // Utilisation de `switchLanguage`
  


  useEffect(() => {
    setTimeout(() => {
      setShowShortname(true);
      gsap.fromTo(
        ".shortname",
        { scale: 0.5, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1.5, ease: "power2.out" }
      );
    }, 2500);
  }, []);

  const classes = useStyles();

  const shortname = (name) => {
    if (name.length > 12) {
      return name.split(" ")[0];
    } else {
      return name;
    }
  };

  return (
    <div className="navbar">
      <div className="navbar--container">
        <h1
          className="shortname"
          style={{
            color: theme.secondary,
            visibility: showShortname ? "visible" : "hidden",
          }}
        >
          {shortname(headerData.name.en)}
        </h1>

        <IoMenuSharp
          className={classes.navMenu}
          onClick={handleDrawerOpen}
          aria-label="Menu"
          id="navicon"
        />
      </div>
      <div className="langue--container">
      <select 
          value={language}
          onChange={(e) => switchLanguage(e.target.value)}  // Changer la langue avec `switchLanguage`
          className="select--langue"
        >
          <option value="en">English</option>
          <option value="fr">Français</option>
        </select>
        
      </div>
      <Drawer
        variant="temporary"
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleDrawerClose();
          } else if (reason !== "escapeKeyDown") {
            handleDrawerClose();
          }
        }}
        anchor="left"
        open={open}
        classes={{ paper: classes.MuiDrawer }}
        className="drawer"
        disableScrollLock={true}
      >
        <div className="div-closebtn">
          <CloseIcon
            onClick={handleDrawerClose}
            onKeyDown={(e) => {
              if (e.key === " " || e.key === "Enter") {
                e.preventDefault();
                handleDrawerClose();
              }
            }}
            className={classes.closebtnIcon}
            role="button"
            tabIndex="0"
            aria-label="Close"
          />
        </div>
        <br />

        <div onClick={handleDrawerClose}>
          <div className="navLink--container">
            <Fade left>
              <NavLink to="/" smooth={true} spy="true" duration={2000}>
                <div className={classes.drawerItem}>
                  <IoHomeSharp className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>Home</span>
                </div>
              </NavLink>
            </Fade>

            <Fade left>
              <NavLink to="/#about" smooth={true} spy="true" duration={2000}>
                <div className={`${classes.drawerItem} drawerItem`}>
                  <FaUser className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>About</span>
                </div>
              </NavLink>
            </Fade>

            <Fade left>
              <NavLink
                to="/#education"
                smooth={true}
                spy="true"
                duration={2000}
              >
                <div className={`${classes.drawerItem} drawerItem`}>
                  <HiDocumentText className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>Education</span>
                </div>
              </NavLink>
            </Fade>

            <Fade left>
              <NavLink to="/#skills" smooth={true} spy="true" duration={2000}>
                <div className={`${classes.drawerItem} drawerItem`}>
                  <BsFillGearFill className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>Skills</span>
                </div>
              </NavLink>
            </Fade>

            <Fade left>
              <NavLink to="/#projects" smooth={true} spy="true" duration={2000}>
                <div className={`${classes.drawerItem} drawerItem`}>
                  <FaFolderOpen className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>Projects</span>
                </div>
              </NavLink>
            </Fade>

            <Fade left>
              <NavLink
                to="/#achievements"
                smooth={true}
                spy="true"
                duration={2000}
              >
                <div className={`${classes.drawerItem} drawerItem`}>
                  <img src={certIcon} className={classes.drawerIcon} style={{width:"25px",height:"18px"}} />
                  <span className={classes.drawerLinks}>Achievements</span>
                </div>
              </NavLink>
            </Fade>

            <Fade left>
              <NavLink
                to="/#contactMe"
                smooth={true}
                spy="true"
                duration={2000}
              >
                <div className={`${classes.drawerItem} drawerItem`}>
                  <MdPhone className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>Contact</span>
                </div>
              </NavLink>
            </Fade>
          </div>
        </div>
      </Drawer>

    </div>
  );
}

export default Navbar;
